import { Icon, IconVariants, Text, TextArea, TextVariants } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import React, { Dispatch, SetStateAction } from "react";

import { Col, Row } from "@/components";

interface ICommandInputBoxProps {
  label: string;
  value: string;
  onValueChange: Dispatch<SetStateAction<string>>;
  isVisible: boolean;
  onClose: () => void;
  isDisabled: boolean;
}

export default function CommandInputBox({ label, value, onValueChange, isVisible, onClose, isDisabled }: ICommandInputBoxProps) {
  const { t } = useTranslation();
if (!isVisible) return null;

  const handleClose = () => {
    onClose();
    onValueChange("");
  };

  return (
    <Col className="border border-solid border-gray-8 p-sm rounded-md gap-1 mb-sm focus-within:bg-gray-4">
      <Row className="bg-gray-7 rounded-[4px] px-sm py-0.5 justify-between">
        <Text variant={TextVariants.LABEL_MEDIUM_REGULAR} className="!font-roboto-mono">
          {label}
        </Text>
        <button className="flex bg-transparent items-center cursor-pointer !text-gray-12" onClick={handleClose}>
          <Icon icon={IconVariants.CLOSE} className="size-[14px]" />
        </button>
      </Row>
      <TextArea
        rows={1}
        maxRows={3}
        placeholder={t("chat:chatInput.placeholder.commandInput")}
        className="text-label-md bg-transparent !ring-0 !p-0 font-roboto-mono"
        value={value}
        onChange={onValueChange}
        disabled={isDisabled}
      />
    </Col>
  );
}
